module.exports = __webpack_public_path__ + "img/vol02_cup01_cover02.07fcc9bc.jpg";